/**
 * Regex used in application
 */
export const Regex = {
  NUMBER_NO_LEADING_ZERO: /^([1-9][0-9]*)$/,
  LOT_NUMBER: /^[0-9a-zA-Z\-_]{1,16}$/,
  NAME: /^[a-zA-Z_']*$/,
  GENERAL: /^[\w.'/,# \-]*$/,
  NUMBER: /^(\d)+$/,
  ALPHA: /^([a-zA-Z ])+$/,
  PHONE: /^\d{10}$/,
  // tslint:disable-next-line: max-line-length
  EMAIL:
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  ZIP: /^(\d{5}-\d{4}|\d{5})$/,
  COMMENTS: /^[\w - ]*$/,
  ANOTHER_NAME: /^[A-Za-z.\s-']+$/,
  ANOTHER_GENERAL: /^[\w - ,.'#-]*$/,
  FACILITY_ID: /^[\d\s]+$/,
  FACILITY_NAME: /^\d{0,9}[ a-zA-Z][\w ' , . # /\(\)-]*$/,
  // tslint:disable-next-line: max-line-length
  PASSWORD:
    /^((?=.*[A-Z])(?=.*[a-z])(?=.*\d)|(?=.*[a-z])(?=.*\d)(?=.*[~!@#$%^&*_+=|\\(\){}[\]:;"<>,.?/ \-])|(?=.*[A-Z])(?=.*\d)(?=.*[~!@#$%^&*_+=|\\(\){}[\]:;"<>,.?/ \-])|(?=.*[A-Z])(?=.*[a-z])(?=.*[~!@#$%^&*_+=|\\(\){}[\]:;"<>,.?/ \-])).{8,15}$/,
  ALPHA_NUMERIC: /^([a-zA-Z0-9])+$/,
  FIRST_ALPHA_NUMERIC: /^[a-zA-Z][\w.'/,# \-]*$/,
  VFC: /^\s*([a-zA-Z0-9\-])+$/,
  VFC_INV: /^([a-zA-Z0-9\-]{1,}|[0-9]{1,5})$/,         
  FULL_NAME: /^[a-zA-Z_ \-']*$/,
  USER_NAME: /[^]*/,
  SIGNATURE_USER_NAME: /^[a-zA-Z][\w -]*$/,
  NUMBER_HYPHEN: /^[0-9 \-]/,
  SFTP: /^[a-zA-Z][\w_\-]*$/,
  // tslint:disable-next-line: max-line-length
  MULTI_EMAIL:
    /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25}(;[ ]{0,1}([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})*$/,
  // tslint:disable-next-line: max-line-length
  MULTI_EMAIL_COMMA_SEPARATED:
    /^(([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)(\s*,\s*|\s*$))*$/,
  DOSAGE_AMOUNT: /^[a-zA-Z0-9. \s']*$/,
  TEMPR_REGEX: /^-?\d*\.?\d+$/,
  CDC_COST: /^[0-9]{1,8}(\.[0-9]{1,2})?$/,
  CONTRACT_NUMBER: /^[0-9a-zA-Z\-_]{1,14}$/,
  REGISTRY_ID_COMMA: /^(\d+)(,\s*\d+)*$/,
  ADDRESS_LINE_REGEX:
    /^(?![\w.'\/,# \-]*(?:(.*((p|post)[-.\s]*(o|off|office)[-.\s]*(box|bin|drawer)[-.\s]*)|.*((p |post)[-.\s]*(box|bin|drawer)[-.\s]*))))[\w.'\/,# \-]*$/i,
};
